import Styled from "styled-components";
export const CardWrap = Styled.section `
    display: flex;
	i {
		height: 14px;
		width: 14px;
		position: relative;
		display: inline-block;
		margin-right: 2px;
		background-image: url("https://d1qtrifip0fug.cloudfront.net/newtights/images/star_normal.29bd8ac9a7db81ac20257f7d0e63117e.svg");
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;

		& > span {
			position: absolute;
			background-image: url("https://d1qtrifip0fug.cloudfront.net/newtights/images/star_choose.8f828c3776c7e16504d3a1da881b8187.svg");
			background-repeat: no-repeat;
		}

		&[data-active] {
			background-image: url("https://d1qtrifip0fug.cloudfront.net/newtights/images/star_choose.8f828c3776c7e16504d3a1da881b8187.svg");
		}
	}
`;
export const CardWrapWithMobile = Styled(CardWrap) `
	color: #ddd;
	font-size: 0;
	position: relative;
	display: table;
	padding: 0;
    margin-right: .75rem;
    i {
        height: .75rem;
        width: .75rem;
    }

	.bottom {
		padding: 0;
		display: block;
		z-index: 0;
	}
	.top {
		color: #ffce26;
		padding: 0;
		position: absolute;
		z-index: 1;
		display: block;
		top: 0;
		left: 0;
		overflow: hidden;
		white-space: nowrap;
	}
`;
